// Scroll reveal: .reveal 要素にビューポート侵入時 .in を付与
(function () {
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    const showAll = () => document.querySelectorAll('.reveal').forEach((el) => el.classList.add('in'));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showAll);
    else showAll();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  const init = () => document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
